import {
    CognitoIdentityProviderClient,
    ResendConfirmationCodeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const cognitoClient = new CognitoIdentityProviderClient({ region: "ca-central-1" });

/**
 * Resends verification code to the user's email address
 * @param email The email address to send verification code to
 * @returns A promise that resolves when the code is sent
 */
export const resendVerificationCode = async (email: string): Promise<void> => {
    try {
        // Using Cognito's ResendConfirmationCodeCommand to resend the verification code to the user's email address
        const command = new ResendConfirmationCodeCommand({
            ClientId: "5u806hjmmcee0qu442qddug8gv", // User Pool Client ID TODO: Move to config
            Username: email,
        });

        const response = await cognitoClient.send(command);
    } catch (error) {
        console.error("❌ Failed to resend verification code:", error);
        throw error;
    }
};

/*
TODO:
- Add a retry limit to the resendVerificationCode function
- Show a countdown timer before the user can resend the code again
*/
